import style from "./index.module.css";
import classNames from "classnames";

function Row(props) {
  const { children, className, ...extra } = props;

  return (
    <div className={classNames(style.row, className)} {...extra}>
      {children}
    </div>
  );
}

export function RowStart(props) {
  const { className, ...extra } = props;
  return <Row className={classNames(style.start, className)} {...extra} />;
}
export function RowEnd(props) {
  const { className, ...extra } = props;
  return <Row className={classNames(style.end, className)} {...extra} />;
}
export function RowCenter(props) {
  const { className, ...extra } = props;
  return <Row className={classNames(style.center, className)} {...extra} />;
}
export function RowAround(props) {
  const { className, ...extra } = props;
  return <Row className={classNames(style.around, className)} {...extra} />;
}
export function RowBetween(props) {
  const { className, ...extra } = props;
  return <Row className={classNames(style.between, className)} {...extra} />;
}
export function RowEvenly(props) {
  const { className, ...extra } = props;
  return <Row className={classNames(style.evenly, className)} {...extra} />;
}
